/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import SendOptions from './SendOptions';

/**
 * The SendMessageToCurrentApproversRequest model module.
 * @module model/SendMessageToCurrentApproversRequest
 * @version V1
 */
class SendMessageToCurrentApproversRequest {
    /**
     * Constructs a new <code>SendMessageToCurrentApproversRequest</code>.
     * @alias module:model/SendMessageToCurrentApproversRequest
     */
    constructor() { 
        
        SendMessageToCurrentApproversRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SendMessageToCurrentApproversRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SendMessageToCurrentApproversRequest} obj Optional instance to populate.
     * @return {module:model/SendMessageToCurrentApproversRequest} The populated <code>SendMessageToCurrentApproversRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SendMessageToCurrentApproversRequest();

            if (data.hasOwnProperty('approverContactIds')) {
                obj['approverContactIds'] = ApiClient.convertToType(data['approverContactIds'], ['Number']);
            }
            if (data.hasOwnProperty('reviewerContactIds')) {
                obj['reviewerContactIds'] = ApiClient.convertToType(data['reviewerContactIds'], ['Number']);
            }
            if (data.hasOwnProperty('sendOptions')) {
                obj['sendOptions'] = SendOptions.constructFromObject(data['sendOptions']);
            }
            if (data.hasOwnProperty('subject')) {
                obj['subject'] = ApiClient.convertToType(data['subject'], 'String');
            }
            if (data.hasOwnProperty('message')) {
                obj['message'] = ApiClient.convertToType(data['message'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SendMessageToCurrentApproversRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SendMessageToCurrentApproversRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is an array
        if (!Array.isArray(data['approverContactIds'])) {
            throw new Error("Expected the field `approverContactIds` to be an array in the JSON data but got " + data['approverContactIds']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['reviewerContactIds'])) {
            throw new Error("Expected the field `reviewerContactIds` to be an array in the JSON data but got " + data['reviewerContactIds']);
        }
        // ensure the json data is a string
        if (data['subject'] && !(typeof data['subject'] === 'string' || data['subject'] instanceof String)) {
            throw new Error("Expected the field `subject` to be a primitive type in the JSON string but got " + data['subject']);
        }
        // ensure the json data is a string
        if (data['message'] && !(typeof data['message'] === 'string' || data['message'] instanceof String)) {
            throw new Error("Expected the field `message` to be a primitive type in the JSON string but got " + data['message']);
        }

        return true;
    }


}



/**
 * @member {Array.<Number>} approverContactIds
 */
SendMessageToCurrentApproversRequest.prototype['approverContactIds'] = undefined;

/**
 * @member {Array.<Number>} reviewerContactIds
 */
SendMessageToCurrentApproversRequest.prototype['reviewerContactIds'] = undefined;

/**
 * @member {module:model/SendOptions} sendOptions
 */
SendMessageToCurrentApproversRequest.prototype['sendOptions'] = undefined;

/**
 * @member {String} subject
 */
SendMessageToCurrentApproversRequest.prototype['subject'] = undefined;

/**
 * @member {String} message
 */
SendMessageToCurrentApproversRequest.prototype['message'] = undefined;






export default SendMessageToCurrentApproversRequest;

